const options = {
  5: "bg-rose-400/5",
  10: "bg-rose-400/10",
  25: "bg-rose-400/25",
  50: "bg-rose-400/50",
  75: "bg-rose-400/75",
  90: "bg-rose-400/90",
  100: "bg-rose-400",
};

const from = {
  5: "from-rose-400/5",
  10: "from-rose-400/10",
  25: "from-rose-400/25",
  50: "from-rose-400/50",
  75: "from-rose-400/75",
  90: "from-rose-400/90",
  100: "from-rose-400",
};

export default function getBackgroundRose400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
